import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const DashboardFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M9.95 3.13H4.5A1.37 1.37 0 0 0 3.13 4.5v7.47c0 .757.613 1.37 1.37 1.37h5.45a1.37 1.37 0 0 0 1.37-1.37V4.5a1.37 1.37 0 0 0-1.37-1.37ZM9.92 14.47H4.53a1.4 1.4 0 0 0-1.4 1.4v3.62a1.4 1.4 0 0 0 1.4 1.4h5.39a1.4 1.4 0 0 0 1.4-1.4v-3.62a1.4 1.4 0 0 0-1.4-1.4ZM19.5 10.68h-5.45a1.37 1.37 0 0 0-1.37 1.37v7.47c0 .757.613 1.37 1.37 1.37h5.45a1.37 1.37 0 0 0 1.37-1.37v-7.47a1.37 1.37 0 0 0-1.37-1.37ZM19.47 3.13h-5.39a1.4 1.4 0 0 0-1.4 1.4v3.62a1.4 1.4 0 0 0 1.4 1.4h5.39a1.4 1.4 0 0 0 1.4-1.4V4.53a1.4 1.4 0 0 0-1.4-1.4Z"
      fill={color}
    />
  </Svg>
)

export default DashboardFilled
